// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-timeline:before{left:143px!important}.v-timeline-item__body{max-width:calc(100% - 192px)!important}.v-timeline-item__opposite{max-width:96px!important}", ""]);
// Exports
module.exports = exports;
